<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="12.779"
      viewBox="0 0 14.376 12.779"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Shuffle-2"
        d="M12.546,8.222a.8.8,0,0,0-1.132,1.127l.234.236H10.383a3.195,3.195,0,0,1,0-6.389h1.268l-.234.232A.8.8,0,1,0,12.543,4.56l1.6-1.59a.8.8,0,0,0,0-1.129l-1.6-1.6a.8.8,0,0,0-1.132,1.127l.234.236H10.383A4.788,4.788,0,0,0,6.389,3.747,4.788,4.788,0,0,0,2.4,1.6H.8a.8.8,0,1,0,0,1.6H2.4a3.195,3.195,0,1,1,0,6.389H.8a.8.8,0,0,0,0,1.6H2.4A4.788,4.788,0,0,0,6.389,9.033a4.788,4.788,0,0,0,3.993,2.149h1.268l-.234.232a.8.8,0,1,0,1.126,1.132l1.6-1.59a.8.8,0,0,0,0-1.129Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RandomIcon extends Vue {}
</script>

<style></style>
